import { format } from 'date-fns';

import Avatar from '@mui/material/Avatar';

import { StatusFigurant } from 'models';

import { KeySrcTypes, SRC_TYPES } from '../../@types';
import * as S from '../../styles';
import { stringAvatar } from '../../utils';
import { IAttachment } from 'components/modules/UploadPhotos/types';

type Props = {
  src?: KeySrcTypes;
  figurantUnavailable: boolean;
  missingInformation: boolean;
  colorUnavailableFigurant: string;
  colorSelectedFigurant: string;
  statusColor: () => string;
  item: StatusFigurant;
  updated_at: Date;
  showBlock: boolean;
  name: string;
  fileCover?: IAttachment;
};

export const Header = ({
  src,
  figurantUnavailable,
  missingInformation,
  colorSelectedFigurant,
  colorUnavailableFigurant,
  statusColor,
  item,
  updated_at,
  showBlock,
  name,
  fileCover,
}: Props) => {
  const figurantClimbed = src === SRC_TYPES.CLIMBED;

  return (
    <S.Header gap="8px">
      <Avatar {...stringAvatar(name)} src={fileCover?.preSignedUrl} />
      <S.ContainerHeader>
        <S.ContainerTitle>
          <S.Title
            color={
              (figurantUnavailable || missingInformation) && figurantClimbed
                ? colorUnavailableFigurant
                : colorSelectedFigurant
            }
            title={name}
          >
            {name}
          </S.Title>
        </S.ContainerTitle>
        <S.Status color={statusColor()} disabled={figurantClimbed ? item.isActive : true}>
          {!showBlock && !missingInformation && `Atualizado em ${format(updated_at, 'dd/MM/yyyy')}`}
          {showBlock && !missingInformation ? 'Bloqueado' : ''}
          {missingInformation && 'Dados incompletos'}
        </S.Status>
      </S.ContainerHeader>
    </S.Header>
  );
};
